import { isBigBimViewerPerformanceOn } from "./big_bim_viewer_performance";
export type InstanceTree = Autodesk.Viewing.InstanceTree;

// TODO: What's a reasonable way to test this?
export function getAllForgeInstanceTreeIds(tree: InstanceTree): number[] {
  const allDbIds = [];
  if (!tree) {
    console.warn("No instance tree found on the model");
    return allDbIds;
  }

  enumAllNodes(tree, (dbId) => {
    if (tree.getChildCount(dbId) === 0) {
      allDbIds.push(dbId);
    }
  });

  return allDbIds;
}

export function enumAllNodes(tree: InstanceTree, callback: (dbId: number) => void) {
  const rootId = tree.getRootId();
  tree.enumNodeChildren(
    rootId,
    callback,
    true
  );
}

/**
 * Calls back with each fragment of an element. A big model can load without an instance tree (the 1.34M-element
 * big-bim floor does), so without one this goes through the fragment map that comes with the geometry.
 */
export function enumElementFragments(model: Autodesk.Viewing.Model, dbId: number, callback: (fragmentId: number) => void) {
  const tree = model.getInstanceTree();
  if (tree) {
    tree.enumNodeFragments(dbId, callback);
    return;
  }
  if (!isBigBimViewerPerformanceOn()) {
    return;
  }
  const fragmentIds = model.getData()?.fragments?.dbId2fragId?.[dbId];
  if (Array.isArray(fragmentIds)) {
    fragmentIds.forEach(callback);
  } else if (fragmentIds != null) {
    callback(fragmentIds);
  }
}

/** Every element with geometry in the model; from the instance tree, or the fragment map when there's no tree. */
export function getAllElementIds(model: Autodesk.Viewing.Model): number[] {
  const tree = model.getInstanceTree();
  if (tree || !isBigBimViewerPerformanceOn()) {
    return getAllForgeInstanceTreeIds(tree);
  }
  const dbId2fragId = model.getData()?.fragments?.dbId2fragId;
  return dbId2fragId ? Object.keys(dbId2fragId).map(Number) : [];
}

/**
 * Turns an element off or back on, like the model's visibilityManager.setNodeOff. That needs an instance tree:
 * without one it takes the element id as a fragment id and turns the wrong geometry off.
 */
export function setElementOff(model: Autodesk.Viewing.Model, dbId: number, off: boolean) {
  if (model.getInstanceTree() || !isBigBimViewerPerformanceOn()) {
    model.visibilityManager.setNodeOff(dbId, off);
  } else {
    const fragmentList = model.getFragmentList();
    enumElementFragments(model, dbId, (fragmentId) => fragmentList.setFragOff(fragmentId, off));
  }
}
